export default __webpack_public_path__ + "static/logo-white-8587ab2a6d20c60b24d096400dae05ae.svg";